import { createRoot } from 'react-dom/client'

import App from './App'

const appElement = document.getElementById('app')
if (!appElement) {
  throw new Error("Missing 'app' container element.")
}

createRoot(appElement).render(<App />)
